const NOTIFICATION_MODULE_PROVIDERS = [];

export {NOTIFICATION_MODULE_PROVIDERS};
